import React, { useState } from 'react';
import './NewsandUpdatesDashboard.css';

const NewsandUpdatesDashboard = () => {
  const [newsItems, setNewsItems] = useState([
    { id: 1, topic: 'Recent Update', description: 'Recent updates in taxation include changes...', image: '' },
    { id: 2, topic: 'Technology Update', description: 'Taxation technology is rapidly evolving...', image: '' }
  ]);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({ topic: '', description: '', image: '' });

  const handleAdd = () => {
    if (!formData.topic || !formData.description) {
      alert('Please fill in topic and description');
      return;
    }

    const newItem = {
      id: Date.now(),
      ...formData
    };
    setNewsItems(prev => [...prev, newItem]);
    setFormData({ topic: '', description: '', image: '' });
  };

  const handleEdit = (item) => {
    setEditingItem(item.id);
    setFormData({ topic: item.topic, description: item.description, image: item.image });
  };

  const handleUpdate = () => {
    setNewsItems(prev => prev.map(item => 
      item.id === editingItem 
        ? { ...item, ...formData }
        : item
    ));
    setEditingItem(null);
    setFormData({ topic: '', description: '', image: '' });
  };

  const handleDelete = (id) => {
    if (window.confirm('Delete this news item?')) {
      setNewsItems(prev => prev.filter(item => item.id !== id));
    }
  };

  const handleCancel = () => {
    setEditingItem(null);
    setFormData({ topic: '', description: '', image: '' });
  };

  return (
    <div className="news-dashboard-container">
      <div className="news-dashboard-header">
        <h1 className="news-dashboard-title">News & Updates Management</h1>
        <p className="news-dashboard-subtitle">Create and manage news articles and updates</p>
      </div>

      <div className="news-dashboard-content">
        <div className="news-form-section">
          <h2 className="news-section-title">
            {editingItem ? 'Edit News Item' : 'Add New News Item'}
          </h2>
          
          <div className="news-form-group">
            <label className="news-form-label">Topic / Title</label>
            <input
              type="text"
              value={formData.topic}
              onChange={(e) => setFormData({...formData, topic: e.target.value})}
              className="news-form-input"
              placeholder="Enter news topic"
            />
          </div>

          <div className="news-form-group">
            <label className="news-form-label">Description</label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({...formData, description: e.target.value})}
              className="news-form-textarea"
              placeholder="Enter full description"
              rows="6"
            />
          </div>

          <div className="news-form-group">
            <label className="news-form-label">Image URL</label>
            <input
              type="text"
              value={formData.image}
              onChange={(e) => setFormData({...formData, image: e.target.value})}
              className="news-form-input"
              placeholder="Enter image URL or path"
            />
          </div>

          {formData.image && (
            <div className="news-image-preview">
              <label className="news-form-label">Image Preview</label>
              <div className="news-preview-box">
                <img src={formData.image} alt="Preview" onError={(e) => e.target.style.display = 'none'} />
              </div>
            </div>
          )}

          <div className="news-button-group">
            {editingItem ? (
              <>
                <button onClick={handleUpdate} className="news-btn-primary">
                  Update News
                </button>
                <button onClick={handleCancel} className="news-btn-secondary">
                  Cancel
                </button>
              </>
            ) : (
              <button onClick={handleAdd} className="news-btn-primary">
                Add News Item
              </button>
            )}
          </div>
        </div>

        <div className="news-list-section">
          <h2 className="news-section-title">
            Current News Items ({newsItems.length})
          </h2>
          
          <div className="news-items-list">
            {newsItems.length === 0 ? (
              <p className="news-empty-text">No news items yet. Add your first one above.</p>
            ) : (
              newsItems.map(item => (
                <div key={item.id} className="news-item-card">
                  <div className="news-item-preview">
                    {item.image ? (
                      <img src={item.image} alt={item.topic} />
                    ) : (
                      <div className="news-no-image">No Image</div>
                    )}
                  </div>
                  <div className="news-item-info">
                    <h3 className="news-item-title">{item.topic}</h3>
                    <p className="news-item-desc">
                      {item.description.substring(0, 100)}
                      {item.description.length > 100 ? '...' : ''}
                    </p>
                  </div>
                  <div className="news-item-actions">
                    <button 
                      onClick={() => handleEdit(item)}
                      className="news-btn-edit"
                    >
                      Edit
                    </button>
                    <button 
                      onClick={() => handleDelete(item.id)}
                      className="news-btn-delete"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsandUpdatesDashboard;